import React, { PureComponent } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { Input } from '../../common/components';
import { updateBreakdown } from '../services/breakdown.service';
import PriceModel from '../models/price.model';

const initialState = {
  price: '',
};

class PriceForm extends PureComponent {
  state = cloneDeep(initialState);


  onInputChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  }


  onFormSave = async () => {
    try {
      const {
        price,
      } = this.state;

      const { breakdownId, refresh, closeModal } = this.props;


      const priceModel = new PriceModel({ price });
      const errors = priceModel.validate();

      if (!errors) {
        try {
          await updateBreakdown({ id: breakdownId, price });
        } catch (err) {
          console.log(errors);
        }
        await refresh();
        closeModal();
      }


      this.setState({ errors });
    } catch (error) {
      console.error(error);
    }
  }


  render() {
    const {
      price,
      errors,
    } = this.state;


    return (
      <>
        <div className="content">
          <div className="card mb-0">
            <div className="card-header">
              Dodaj cenę
            </div>
            <div className="card-body card-block pb-0">
              <div className="form-horizontal">
                <Input
                  label="Cena"
                  errors={errors}
                  id="price"
                  value={price}
                  onChange={this.onInputChange}
                  horizontal
                />
              </div>
            </div>
            <div className="d-flex justify-content-end p-3">
              <button
                type="button"
                onClick={this.onFormSave}
                className="btn btn-primary btn-bg"
              >
                Zapisz
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PriceForm;
